import React from "react";
import TrophyIcon from "../../images/TrophyIcon";
import Typography, { TypographyVariant } from "./Typography";

interface ProgressBarProps {
  progress: number;
  size?: "large" | "medium" | "small";
  className?: string;
  textClass?: string;
  typographyVariant?: TypographyVariant;
  showTrophy?: boolean;
  showProgressText?: boolean;
}

const sizeMap = {
  large: "w-[250px] md:w-[400px] lg:w-[700px] xl:w-[940px]",
  medium: "w-[194px]",
  small: "w-[110px]",
};

const ProgressBar: React.FC<ProgressBarProps> = ({ progress, size = "medium", className, textClass, typographyVariant = "p", showTrophy = true, showProgressText = true, }) => {
  const progressWidth = `${progress}%`;
  const barSize = sizeMap[size];
  return (
    <div className={`flex items-center ${className}`}>
      <div className={`relative flex items-center h-2 bg-gray-200 rounded-full ${barSize}`}>
        <div
          className='h-2 bg-system-blue rounded-full'
          style={{ width: progressWidth }}
        ></div>
        {showTrophy && (
          <TrophyIcon
            width={18}
            height={18}
            fillColor={progress === 100 ? "#FFA94C" : "white"}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-1/2"
          />
        )}
      </div>
      {showProgressText && (
      <div className='flex items-center gap-6 ml-4'>
        <Typography variant={typographyVariant} className={`${textClass}`}>
          {progress}% complete
        </Typography>
      </div>
      )}
    </div>
  );
};

export default ProgressBar;
